module.exports = __webpack_public_path__ + "img/logo_anclaje.76124edb.png";